// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_ActivityEventType.proto

export enum ENUM_ActivityEventType {
  ACTIVITY_EVENT_TYPE_UNSPECIFIED = 'ACTIVITY_EVENT_TYPE_UNSPECIFIED',
  ACTIVITY_EVENT_TYPE_ROUTE = 'ACTIVITY_EVENT_TYPE_ROUTE',
  ACTIVITY_EVENT_TYPE_CLICK = 'ACTIVITY_EVENT_TYPE_CLICK',
  ACTIVITY_EVENT_TYPE_MODAL = 'ACTIVITY_EVENT_TYPE_MODAL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
